export namespace Environment {
  export const language = "en";

  export const gcmKey =
    "AAAA6vJz8Z0:APA91bFrEMaqMk9M5AjVJTmRIRXFIU-R5dtxb6qU7nhtUxCq9tDozZrBRMRLzgQoZ0liJJUjNWLHqsm6eFTrCwT9Kl9_AeodxWQBtUkuR2Za6kJhmfCkly491hTnDClSlFG1lB6qZ2y1";

  export const firebase = {
    apiKey: "AIzaSyAtXgUQ3D9H8jZKkZnA9740gSbKdwNDP0g",
    authDomain: "native-chain.firebaseapp.com",
    databaseURL: "https://native-chain.firebaseio.com",
    projectId: "native-chain",
    storageBucket: "native-chain.appspot.com",
    messagingSenderId: "893533317914"
  };

  export const googleWebClientId: string =
    "983397565008-b2hlfm488ekse1q92430c9ml09j4unju.apps.googleusercontent.com";

  export const loading = {
    spinner: "crescent"
  };

  export const toast = {
    position: "bottom",
    showCloseButton: true,
  };

  export const toastDuration = 3000;
  export const shortToastDuration = 1500;

  //Genesis Block will be used to verify blockchain's integrity
  export const genesisBlock = {
    count: 0,
    hash: "d9bd41d100a8da5bb53d80721e0ec827ca49f3219f5c8a81d2919c4983436659",
    dates: ["2018-09-08T12:51:01-05:00"]
  };

  export const version = "blockchain/testnet4";

  export const isTestnet=true;

  export const stripe = {
    production: false,
    stripeKey: "pk_test_G70gfcCqLnkTagQ5UUghtH5q"
  };

  export const showWalkthrough = true;

  export const difficulty = 3;

  export const barcodeSettings = {
    preferFrontCamera: false,
    showTorchButton: true,
    saveHistory: true,
    disableAnimations: false,
    orientation: "portrait"
  };
}



// WEBPACK FOOTER //
// ./src/environment/environment.ts